

import { Dialog } from 'primereact/dialog';
import { useMatchMedia } from 'primereact/hooks';
import { classNames } from 'primereact/utils';

const Modal = (props) => {
    const isDesktop = useMatchMedia(`screen and (min-width: 768px)`);

    return (
        <Dialog {...props} style={{ width: '36rem' }} draggable={false} position={isDesktop ? 'center' : 'bottom'} pt={{
            root: {
                className: 'modal h-full md:h-auto border-none md:border-1 max-w-full m-0',
                style: {paddingTop: 'env(safe-area-inset-top)'}
            },
            header: {
                className: 'p-3 md:p-4 border-bottom-1 surface-border'
            },
            content: {
                className: classNames('p-3 md:px-4 pt-3 overflow-x-hidden', props.footer ? "pb-0" : "pb-4")
            },
            footer: {
                className: 'pt-3 md:pt-4 px-3 md:px-4 border-top-1 surface-border',
                style: {paddingBottom: 'max(env(safe-area-inset-bottom), 1.5rem)'}
            }
        }}>

        </Dialog>
    )
}

export default Modal;